/*
 * This is a reimplementation of what exists in our HTML template files
 * already. Once the React tree mounts, this is what gets rendered first, until
 * the app is ready to go.
 */

import {View} from 'react-native'

import {atoms as a} from '#/alf'
import {SplashLogo} from '#/view/icons/SplashLogo'

const size = 200

export function Splash() {
  return (
    <View style={[a.fixed, a.inset_0, a.align_center, a.justify_center, {backgroundColor: '#000000'}]}>
      <SplashLogo
        size={size}
        accessibilityLabel="SHXRE"
        style={[a.relative, {top: -50}]}
      />
    </View>
  )
}
